import React from "react";
import OrganisationOverview from "../features/organisationWallet/OrganisationOverview";

const OrganisationWallet = () => {
  return (
    <div>
      <OrganisationOverview />
    </div>
  );
};

export default OrganisationWallet;
